<template>
  <VaNavbar class="app-layout-navbar py-2 px-0">
    <template #left>
      <div class="left">
        <Transition v-if="isMobile" name="icon-fade" mode="out-in">
          <VaIcon
            color="primary"
            :name="isSidebarMinimized ? 'menu' : 'close'"
            size="24px"
            style="margin-top: 3px"
            @click="isSidebarMinimized = !isSidebarMinimized"
          />
        </Transition>
        <RouterLink to="/" class="app-brand" aria-label="VETC Recon - Trang chủ">
          <span class="app-brand-mark">V</span>
          <span class="app-brand-copy"><strong>VETC RECON</strong><small>QUẢN LÝ ĐỐI SOÁT</small></span>
        </RouterLink>
      </div>
    </template>
    <template #right>
      <AppNavbarActions class="app-navbar__actions" :is-mobile="isMobile" />
    </template>
  </VaNavbar>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useGlobalStore } from '../../stores/global-store'
import AppNavbarActions from './components/AppNavbarActions.vue'

defineProps({
  isMobile: { type: Boolean, default: false },
})

const GlobalStore = useGlobalStore()

const { isSidebarMinimized } = storeToRefs(GlobalStore)
</script>

<style lang="scss" scoped>
.va-navbar {
  z-index: 2;

  @media screen and (max-width: 950px) {
    .left {
      width: 100%;
    }

    .app-navbar__actions {
      display: flex;
      justify-content: space-between;
    }
  }
}

.left {
  display: flex;
  align-items: center;
  margin-left: 1rem;

  & > * {
    margin-right: 1rem;
  }

  & > *:last-child {
    margin-right: 0;
  }
}

.app-brand { display: inline-flex; align-items: center; gap: 0.62rem; color: var(--va-text-primary); text-decoration: none; }
.app-brand-mark { display: grid; place-items: center; width: 31px; height: 31px; border-radius: 9px; background: var(--va-primary); color: #fff; font-size: 1rem; font-weight: 850; }
.app-brand-copy { display: grid; gap: 0.05rem; line-height: 1.1; }
.app-brand-copy strong { font-size: 0.8rem; font-weight: 850; letter-spacing: 0.12em; }
.app-brand-copy small { color: var(--va-text-secondary); font-size: 0.55rem; font-weight: 750; letter-spacing: 0.09em; }
@media screen and (max-width: 650px) { .app-brand-copy small { display: none; } }

.icon-fade-enter-active,
.icon-fade-leave-active {
  transition: transform 0.5s ease;
}

.icon-fade-enter,
.icon-fade-leave-to {
  transform: scale(0.5);
}
</style>
